export enum RightsholderContactTypes {
    PUBLIC = 'PUBLIC',
    LEGAL = 'LEGAL',
    FINANCE = 'FINANCE',
    COPYRIGHT = 'COPYRIGHT',
    MEMBER_SERVICES = 'MEMBER_SERVICES',
}
